var radiusData = {
    small: "2px",
    base: "4px",
    large: "8px",
};
export var borderRadius = function (size) {
    if (size === void 0) { size = "base"; }
    return radiusData[size];
};
